import {SODeleteUser} from '../../core/user/so-delete-user';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteUser extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteUser;
}